import React from 'react';
import PropTypes from 'prop-types';
import styles from './Tab.module.css';

export const Tab = ({ isActive, children, onClick }) => {
  return (
    <button
      className={isActive ? styles.activeTab : styles.inactiveTab}
      onClick={onClick}
      role="tab"
      aria-selected={isActive}
      tabIndex={0}
    >
      {children}
    </button>
  );
};

Tab.propTypes = {
  isActive: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};
